import React from "react";

/**
 * Error Screen
 * @param {String} err Error string
 * @returns {JSX}
 */
export default function Error({ err = "" }) {
  return (
    <div
      className="loading-screen d-flex flex-column justify-content-center align-items-center lh-sm"
      style={{ height: window.innerHeight }}
    >
      <div className="fs-xxl text-danger bi bi-exclamation-circle"></div>
      <div className="text-danger w-50 text-center fs-1">{err}</div>
      <div className="pad"></div>
      <br />
      <div className="fixed-bottom d-flex">
        <div
          className="border-bottom mx-auto mb-5 border-primary px-2 fs-3 text-primary"
          onClick={() => window.location.reload()}
        >
          Try Again
        </div>
      </div>
    </div>
  );
}
